import { ActivationsTable } from './ActivationsTable';

export const ActivationsPage = () => {
    return (
        <div>
            <ActivationsTable />
        </div>
    );
};
